import React, { useEffect, useState } from "react";
import { getBusinessProductsByStatusAPI } from "../../../service/api_calls/BusinessPreview/BusinessPreviewAPI";
import { getBuyMoreProductDetailsApi } from "../../../service/api_calls/CatalogSync/CatalogSyncApi";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import MultiSelectDropdown from "../../../components/Select/MultiSelectDropdown";
import FormInputBox from "../../../components/Input/FormInputBox";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import {
  BGColor02,
  blackColor,
  blackShade19,
  blueColor04,
  borderTextBoxColor,
  greyColor21,
  greyColor53,
  greyColor9,
  progressBGColor,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import ModalCard from "../../../components/ModalCard";
import LightToolTip from "../../../components/Alerts/LightToolTip";

const NotSyncedSkuDropdown = ({
  value,
  onChange,
  commerceInfo,
  error,
  setError,
}) => {
  const businessId = sessionStorage.getItem("selectedBusinessId");
  const [skuListData, setSkuListData] = useState([]);

  const [openModal, setOpenModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState(0);

  const [loader, setLoader] = useState(false);

  const getNewSkus = async () => {
    setLoader(true);
    // Check if the given product ids present in buymore
    const buyMoreProductRes = await getBuyMoreProductDetailsApi({
      businessId,
      pageNumber: 1,
      skuList: [],
    });

    const buymoreProducts = buyMoreProductRes?.body || [];
    const sortedBuymoreProducts = buymoreProducts.sort((a, b) =>
      a.product_name.localeCompare(b.product_name)
    );

    // const buymoreProductSkus = buymoreProducts;
    // .map((item) => item?.costboondc_portal_sku || "")
    // .filter((sku) => sku !== "");

    const imageLinks = buyMoreProductRes?.image_links || [];

    const updatedBuyMoreSkuInfo = sortedBuymoreProducts?.map((item) => {
      let productPhotoUrl = [];

      // Check if there are image links
      if (imageLinks.length > 0) {
        // Find product images for the given item?.product_id
        const productImages = imageLinks.find(
          (product) => product[item?.product_id]
        );

        if (productImages) {
          // Extract and sort image links
          const images = Object.keys(productImages[item?.product_id])
            .filter((key) => key.startsWith("image_link_"))
            .sort()
            .map((key) => productImages[item?.product_id][key]);

          // Use the first four images or fallback to default image URL
          productPhotoUrl =
            images.length > 0 ? images.slice(0, 4) : [item?.image_url];
        } else {
          productPhotoUrl = [item?.image_url];
        }
      } else {
        productPhotoUrl = [item?.image_url];
      }

      return { ...item, productPhotoUrl };
    });

    const buymoreProductSkus = [...updatedBuyMoreSkuInfo];

    console.log("getNewSkus__buymoreProductSkus", buymoreProductSkus);

    const ALL_PRODUCT_STATUS = ["active", "new", "updated", "draft"];

    const catalogPartnerInfo =
      commerceInfo?.info?.catalogPartnerInfo?.[0] || null;
    const facilityCode = catalogPartnerInfo?.warehouse?.facilityCode || "";

    // Make API requests in parallel
    const result = await Promise.all(
      ALL_PRODUCT_STATUS.map((status) =>
        getBusinessProductsByStatusAPI({
          businessId,
          status,
        })
      )
    );

    // Flatten the list of all product details
    const allProducts = result.flatMap((item) => item?.details || []);
    console.log("getNewSkus__allProducts", allProducts);

    const syncedProductSkuList = allProducts
      ?.map((item) => item?.catalogPartnerItemInfo?.[0]?.skuCode || "")
      .filter((sku) => sku !== "");
    console.log("getNewSkus__syncedProductSkuList", syncedProductSkuList);

    const newSkuList = buymoreProductSkus.filter(
      (item) => !syncedProductSkuList.includes(item?.costboondc_portal_sku)
    );
    console.log("getNewSkus__newSkuList", newSkuList);

    setSkuListData(newSkuList);
    setLoader(false);
  };

  // Toggle Indiviual Row Selection
  const toggleProductRowSelect = (index, isSelected) => {
    const allProducts = [...skuListData];
    const productInfo = allProducts[index] || null;

    if (!productInfo) {
      setSkuListData(allProducts || []);
      return;
    }

    const updatedProductInfo = {
      ...productInfo,
      isSelected: !isSelected,
    };

    allProducts[index] = updatedProductInfo;

    const selectedCount = allProducts?.filter(
      (item) => item?.isSelected
    ).length;

    setSkuListData(allProducts || []);
    setSelectedRows(selectedCount);
  };

  // Handle Select All Product
  const selectAllProductRows = (isSelected) => {
    const allProducts = skuListData?.map((item) => ({
      ...item,
      isSelected: isSelected ? true : false,
    }));

    const selectedCount = allProducts?.filter(
      (item) => item?.isSelected
    ).length;

    setSkuListData((prevState) => allProducts);
    setSelectedRows(selectedCount);
  };

  const handleSubmit = () => {
    if (selectedRows == 0) {
      setError("Select at least one SKU");
      return;
    }

    if (selectedRows > 30) {
      setError("You can import up to 30 SKUs in a single set.");
      return;
    }

    const skuArr = skuListData
      ?.map((item) => {
        if (item?.isSelected) {
          return item?.costboondc_portal_sku || "";
        } else {
          return "";
        }
      })
      .filter((sku) => sku !== "");

    const skuString = skuArr.join(",");
    onChange(skuString);
    setOpenModal(false);
  };

  useEffect(() => {
    getNewSkus();

    return () => {};
  }, []);

  return (
    <Box mb={2}>
      {/* {JSON.stringify(skuListData?.[0])} */}
      {/* <MultiSelectDropdown
        label={`Select SKUs (${skuListData?.length || 'XX'} SKUs)`}
        value={skus}
        onValueChange={(updatedValue) => {
          setSkus(updatedValue);
          onChange(updatedValue?.filter((sku) => sku !== "").join(","));
        }}
        menuList={skuListData || []}
        error={error}
        //   disabled={editOndc}
      /> */}

      <Grid container spacing={2}>
        <Grid item md={10}>
          <FormInputBox
            hideLabel
            placeholder=""
            value={value}
            onChange={({ target }) => {
              // onChange(target?.value);
            }}
            error={error}
            autoComplete="off"
          />
        </Grid>

        <Grid item md={2}>
          <IconButton
            sx={{
              border: `1px solid ${blueColor04}`,
              borderRadius: "6px",
              p: loader ? "6px" : "4px",
              color: blueColor04,
              bgcolor: whiteColor,
              "&:hover": {
                color: whiteColor,
                bgcolor: blueColor04,
              },
              "&.Mui-disabled": {
                border: "1px solid rgba(0,0,0,0.3)",
              },
            }}
            disabled={loader}
            onClick={() => setOpenModal(true)}
          >
            {loader ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <AddRoundedIcon sx={{ fontSize: "20px" }} />
            )}
          </IconButton>
        </Grid>
      </Grid>

      <ProductSelectionModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        selectedRowCount={selectedRows}
        productDetails={skuListData || []}
        toggleProductRowSelect={toggleProductRowSelect}
        selectAllProductRows={selectAllProductRows}
        onApply={handleSubmit}
        error={error}
      />
    </Box>
  );
};

export default NotSyncedSkuDropdown;

const ProductSelectionModal = ({
  openModal,
  setOpenModal,
  selectedRowCount,
  productDetails,
  toggleProductRowSelect,
  selectAllProductRows,
  onApply,
  error,
}) => {
  return (
    <ModalCard
      open={openModal}
      handleClose={() => {
        setOpenModal(false);
      }}
      width="50%"
    >
      <Box sx={{ backgroundColor: whiteColor, borderRadius: 1.8 }}>
        <Box
          sx={{
            backgroundColor: BGColor02,
            p: 1.5,
            borderRadius: "14.4px 14.4px 0 0",
            textAlign: "center",
          }}
        >
          <Typography
            variant="body1"
            fontSize={14}
            fontWeight={600}
            color={blackShade19}
            mb={0.3}
          >
            Select SKUs to Import
            <Typography
              variant="body1"
              fontSize={12.5}
              fontWeight={500}
              color={greyColor9}
            >
              <span
                style={{
                  fontSize: "12.5px",
                  fontWeight: 600,
                  color: blueColor04,
                }}
              >
                {selectedRowCount} of {productDetails?.length}
              </span>{" "}
              rows selected
            </Typography>
          </Typography>
        </Box>

        <Box sx={styles.content}>
          <Box
            sx={{
              border: `1px solid ${progressBGColor}`,
              borderRadius: "10px",
            }}
          >
            <Box borderBottom={`1px solid ${progressBGColor}`} p="6px 10px">
              <Grid container>
                <Grid item md={0.6}>
                  <Checkbox
                    // size=""
                    checked={productDetails?.every((item) => item.isSelected)}
                    onChange={({ target }) => {
                      selectAllProductRows(target.checked);
                    }}
                    sx={styles.checkbox}
                  />
                </Grid>

                <Grid item md={1.2}>
                  <Typography
                    fontSize={12}
                    fontWeight={400}
                    color={blackColor}
                  >
                    Image
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography
                    fontSize={12}
                    fontWeight={400}
                    color={blackColor}
                  >
                    Product Name
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            <Box sx={styles.listContainer}>
              {productDetails?.map((item, index) => (
                <Box
                  key={`sku_${index}`}
                  borderBottom={`1px solid ${progressBGColor}`}
                  p="10px"
                >
                  <Grid container>
                    <Grid item md={0.6}>
                      <Checkbox
                        // size=""
                        checked={item?.isSelected || false}
                        onChange={() => {
                          toggleProductRowSelect(index, item?.isSelected);
                        }}
                        sx={styles.checkbox}
                      />
                    </Grid>

                    <Grid item md={1.2}>
                      <Box sx={styles.imgBox}>
                        <Box
                          component="img"
                          src={item?.image_url}
                          sx={styles.imgContainer}
                        />
                      </Box>
                    </Grid>

                    <Grid item md={9.2}>
                      <Typography
                        fontSize={11.5}
                        fontWeight={400}
                        color={blackColor}
                        lineHeight="20px"
                        title={item?.product_name}
                      >
                        {item?.product_name}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              ))}
            </Box>
          </Box>

          {error ? (
            <Typography
              variant="subtitle1"
              component="p"
              fontSize={12}
              sx={{ mt: "4px !important", textAlign: "start !important" }}
              style={{ color: "red" }}
            >
              {error}
            </Typography>
          ) : null}
        </Box>

        <Stack
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          gap={4}
          sx={{
            backgroundColor: BGColor02,
            p: 2,
            borderRadius: "0 0 14.4px 14.4px",
          }}
        >
          <Button
            variant="contained"
            sx={styles.backBtn}
            disableElevation
            onClick={() => {
              setOpenModal(false);
            }}
          >
            CANCEL
          </Button>

          <Button
            variant="contained"
            disableElevation
            sx={styles.applyBtn}
            onClick={() => {
              onApply();
            }}
            disabled={selectedRowCount == 0}
          >
            Done
          </Button>
        </Stack>
      </Box>
    </ModalCard>
  );
};

const styles = {
  content: {
    // width: "calc(100vw - 310px)",
    p: 2,
  },

  listContainer: {
    height: "50vh",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: "2px",
      height: "2px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: blueColor04,
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },

  imgBox: {
    width: { xs: "25px", md: "45px !important" },
    height: { xs: "25px", md: "45px !important" },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    border: "1px solid #e5e9f0",
    // p: "5px",
    cursor: "pointer",
  },

  imgContainer: {
    backgroundColor: whiteColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: { xs: "25px", md: "38px !important" },
    height: { xs: "25px", md: "38px !important" },
    objectFit: "contain",
  },

  backBtn: {
    fontSize: 12,
    fontWeight: 500,
    backgroundColor: whiteColor,
    border: `1px solid ${blackShade19}`,
    color: blackShade19,
    p: "5px 20px",
    "&:hover": {
      color: blackShade19,
      backgroundColor: whiteColor,
    },
  },

  applyBtn: {
    fontSize: 12,
    fontWeight: 500,
    backgroundColor: blueColor04,
    border: `1px solid ${blueColor04}`,
    color: whiteColor,
    p: "5px 20px",
    "&:hover": {
      color: blueColor04,
      backgroundColor: whiteColor,
    },

    "&.Mui-disabled": {
      border: "none",
    },
  },

  checkbox: {
    color: greyColor21,
    p: 0,
    mt: -0.5,
    transform: "scale(1.3)",
    "&.Mui-checked": {
      color: blueColor04,
    },
  },
};
